import { sharedTheming } from 'shared/sharedTheming';

export const Theming = {
    ...sharedTheming,
    pageBackgroundColor: '#FFF',
};
